import React from 'react'
import IntlMessages from "../helpers/IntlMessages"

export default props => {
    return(
        <div className="loading-wrapper">
            <div className={`loading ${props.className || ""}`}/>
            {props.heading ? <p className={props.headingClassName || ""}><IntlMessages id={props.heading}/></p> : null}
        </div>
    )
}